import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanBEApi } from "~/Services";

export interface DocumentDetailsResponse {
  id: number;
  userName: string;
  email: string;
  name: string;
  role: string;
  password: string;
  createdAt: string;
  updatedAt: string;
}

// edit api call
const fetchUsersDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await eramanBEApi.get(`/admin/users/get?id=${id}`);
  return response.data;
};

const useUsersDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["usersDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchUsersDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useUsersDocumentDetails };
